import { useApp } from '../App';
import { useI18n } from '../i18n/index.jsx';

export default function BottomNav() {
  const { page, setPage, user, testMode, productAccess, isAccountant } = useApp();
  const { t, lang } = useI18n();
  const label = (ru, pl) => lang === 'pl' ? pl : ru;
  
  const isCompanyOwner = !testMode && (user?.account_type === 'own_company' || user?.role === 'company_owner' || user?.role === 'superadmin' || user?._original_role === 'superadmin' || (productAccess?.accounting && !productAccess?.incubator && !productAccess?.genro));
  const isGenroOnly = !!(productAccess?.genro && !productAccess?.incubator && !productAccess?.accounting);

  const items = isAccountant ? [
    { id: 'dashboard', icon: '▦', label: label('Фирмы', 'Firmy') },
    { id: 'accountant_company', icon: '◉', label: label('Обзор', 'Przegląd') },
    { id: 'accountant_sales', icon: '📄', label: label('Продажи', 'Sprzedaż') },
    { id: 'accountant_reports', icon: '▥', label: label('Отчёты', 'Raporty') },
    { id: 'profile', icon: '👤', label: label('Профиль', 'Profil') },
  ] : isCompanyOwner ? [
    { id: 'dashboard', icon: '📊', label: t('nav.cabinet') },
    { id: 'owner_invoices', icon: '📄', label: t('nav.invoices_owner') },
    { id: 'hr_employees', icon: '👷', label: t('nav.hr') },
    { id: 'my_taxes', icon: '🧮', label: t('nav.taxes') },
    { id: 'profile', icon: '👤', label: t('nav.profile_owner') },
   ] : isGenroOnly ? [
    { id: 'dashboard', icon: '🏠', label: t('nav.home') },
    { id: 'genro_entry', icon: '🧠', label: 'Genro AI' },
    { id: 'support', icon: '📞', label: t('nav.profile') },
    { id: 'profile', icon: '👤', label: t('nav.profile') },
  ] : [
    // Incubator client — simplified menu matching dashboard categories
    { id: 'dashboard', icon: '🏠', label: t('nav.home') },
    { id: 'invoices_out', icon: '📄', label: t('nav.proformas') },
    { id: 'work_permit', icon: '📋', label: t('nav.documents') },
    { id: 'support', icon: '📞', label: t('nav.support') },
    { id: 'profile', icon: '👤', label: t('nav.profile') },
  ];

  return (
    <nav className="bottom-nav">
      {items.map(it => {
        const active = page === it.id || (isAccountant && it.id === 'dashboard' && ['accounting_overview', 'accountant_dashboard'].includes(page));
        return (
          <button
            key={it.id}
            className={`nav-item ${active ? 'active' : ''}`}
            onClick={() => setPage(it.id)}
          >
            <span className="nav-icon">{it.icon}</span>
            <span className="nav-label">{it.label}</span>
            {active && <span className="nav-dot" />}
          </button>
        );
      })}
    </nav>
  );
}
